import React from 'react';
import { Button } from 'antd';
import { statusTokens, primaryShades, greyScaleTokens } from '../../../theme/theme';

const ButtonState = ({ state, text, onClick, style, isCircle = false, ...props }) => {

  const buttonStyles = {
    // Versione Inglese
    'Client Rev.': {
      backgroundColor: primaryShades.primary500,
      color: '#FFFFFF',
      border: 'none',
    },
    'Spaarkly Rev.': {
      backgroundColor: primaryShades.primary200,
      color: '#FFFFFF',
      border: 'none',
    },
    'Modelist Rev.': {
      backgroundColor: '#FFFFFF',
      color: primaryShades.primary300,
      border: `1px solid ${primaryShades.primary300}`,
      fontWeight: '400',
    },
    'In Publication': {
      backgroundColor: statusTokens.success,
      color: '#FFFFFF',
      border: 'none',
    },
    'Incomplete': {
      backgroundColor: '#F5F5F5',
      color: greyScaleTokens.grey600,
      border: 'none',
    },

    // Versione Italiana
    'Rev. Cliente': {
      backgroundColor: primaryShades.primary500,
      color: '#FFFFFF',
      border: 'none',
    },
    'Rev. Spaarkly': {
      backgroundColor: primaryShades.primary200,
      color: '#FFFFFF',
      border: 'none',
    },
    'Rev. Modellista': {
      backgroundColor: '#FFFFFF',
      color: primaryShades.primary300,
      border: `1px solid ${primaryShades.primary300}`,
      fontWeight: '400',
    },
    'In Pubblicazione': {
      backgroundColor: statusTokens.success,
      color: '#FFFFFF',
      border: 'none',
    },
    'Incompleto': {
      backgroundColor: '#F5F5F5',
      color: greyScaleTokens.grey600,
      border: 'none',
    },
  };

  // Ottieni lo stile per lo stato corrente dall'oggetto buttonStyles
  // Se lo stato non viene trovato, usa uno stile predefinito grigio
  const stateStyle = buttonStyles[state] || {
    backgroundColor: 'grey',
    color: '#FFFFFF',
    border: 'none',
  };

  // Stili predefiniti per i pulsanti rettangolari e circolari
  // Stili di base che variano in base al tipo di pulsante (rettangolare o circolare)
  const defaultStyle = isCircle ? {
    width: '24px',           // Dimensione fissa per i cerchi
    height: '24px',          // Dimensione fissa per i cerchi
    borderRadius: '50%',     // Forma circolare
    padding: 0,              // Nessun padding interno
    fontSize: '12px',        // Testo più piccolo per i cerchi
    fontWeight: 'bold',      // Testo in grassetto
    display: 'flex',         // Usa flex per centrare il contenuto
    alignItems: 'center',    // Allinea verticalmente al centro
    justifyContent: 'center' // Allinea orizzontalmente al centro
  } : {
    minWidth: '140px',      // Larghezza minima per una migliore resa visiva
    textAlign: 'center',    // Allineamento orizzontale del testo al centro
    fontSize: '14px',       // Dimensione del carattere standard
    padding: '8px 15px',    // Spaziatura interna
    height: '30px',         // Altezza fissa per uniformità
    borderRadius: '4px',    // Bordi leggermente arrotondati
    fontWeight: '500',      // Peso del font medio
    display: 'flex',        // Usa flex per centrare il contenuto
    alignItems: 'center',   // Allinea verticalmente al centro
    justifyContent: 'center' // Allinea orizzontalmente al centro
  };


  // Unisci tutti i livelli di stile con la giusta precedenza:
  // 1. Stili predefiniti (per i pulsanti rettangolari)
  // 2. Stili specifici per stato (colori, bordi, ecc.)
  // 3. Stili inline passati tramite props (massima precedenza)
  const combinedStyle = {
    ...defaultStyle,  // Stili base per primi
    ...stateStyle,    // Gli stili specifici sovrascrivono quelli base
    ...style,         // Gli stili inline sovrascrivono tutto il resto
  };

  return (
    <Button
      onClick={onClick}
      style={combinedStyle}
      {...props}
    >
      {text || state}
    </Button>
  );
};

export default ButtonState;